export default "__VITE_ASSET__DsKPk6RM__"